import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UIList from 'UIComponents/list/UIList';
import Rating from './Rating';
import { QualityRatingsByReviewType } from '../constants/RatingAxes';
import { PILL_RATING } from '../constants/RatingTypes';
export default function QualityDistribution({
  heading,
  hideIfEmptyValue = true,
  labelSize = 'sm',
  qualityRatings,
  reviewType,
  showLabelTooltips = false
}) {
  const qualityRatingsObj = Object.fromEntries(qualityRatings);
  const qualityRatingsOrder = QualityRatingsByReviewType[reviewType];

  const renderQualityRow = (type, value) => {
    const rating = value;

    const labelText = /*#__PURE__*/_jsx("span", {
      style: {
        fontSize: 12
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `marketplace-ui-reviews.qualityDistribution.labels.${reviewType}.${type}`
      })
    });

    const renderedLabel = showLabelTooltips ? /*#__PURE__*/_jsx(UIHelpIcon, {
      className: "display-inline",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `marketplace-ui-reviews.qualityDistribution.tooltips.${reviewType}.${type}`
      }),
      tooltipPlacement: "right",
      children: labelText
    }) : labelText;
    return /*#__PURE__*/_jsx(Rating, {
      "data-test-id": "rating",
      type: PILL_RATING,
      label: renderedLabel,
      labelSize: labelSize,
      rating: rating
    }, `${type}_${rating}`);
  };

  return /*#__PURE__*/_jsxs(UIList, {
    children: [heading && /*#__PURE__*/_jsx("span", {
      className: "is--heading-7 m-bottom-2",
      children: heading
    }), qualityRatingsOrder.map(axis => {
      const rating = qualityRatingsObj[axis];

      if ((rating == null || rating === 'NaN') && hideIfEmptyValue) {
        return null;
      }

      return renderQualityRow(axis, rating);
    })]
  });
}